import { Box, Typography } from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

import { useParams } from 'react-router-dom';

import { MessageAttachment } from '../../../../../resources/discussion/types';

import {
    useGetTrackedTripProperties,
    useTrackEventAmplitude,
} from '../../../../../shared/analytics';

import { DossierId } from '../../../../../resources/dossier/types';

import { TipiCard } from './TipiCard';
import { TipiCompactRow } from './TipiCompactRow';

type TipiSectionProps = {
    tipiLinks: MessageAttachment[];
};

export const TipiSection = ({ tipiLinks }: TipiSectionProps) => {
    const { dossierId } = useParams() as { dossierId: DossierId };
    const { formatMessage } = useIntl();
    const { trackEvent } = useTrackEventAmplitude();
    const trackedTripProperties = useGetTrackedTripProperties(dossierId);

    if (tipiLinks.length === 0) {
        return (
            <Typography color="text.secondary" variant="body2">
                {formatMessage({ id: 'discussion.attachments_list.tipi_proposals_empty' })}
            </Typography>
        );
    }

    const [latest, ...rest] = tipiLinks;

    const onTipiLinkClick = () => {
        trackEvent((ampli, defaultProperties) => {
            ampli.tripPlannerProposalClicked({
                ...defaultProperties,
                ...trackedTripProperties,
            });
        });
    };

    return (
        <Box
            component="ul"
            sx={{
                m: 0,
                p: 0,
                listStyle: 'none',
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'divider',
                '& > li + li': {
                    borderTop: '1px solid',
                    borderColor: 'divider',
                },
                '& > li:first-of-type': {
                    borderTopLeftRadius: 'inherit',
                    borderTopRightRadius: 'inherit',
                },
                '& > li:last-of-type': {
                    borderBottomLeftRadius: 'inherit',
                    borderBottomRightRadius: 'inherit',
                },
            }}
        >
            <TipiCard attachment={latest} onTipiLinkClick={onTipiLinkClick} />
            {rest.map((attachment) => (
                <TipiCompactRow
                    key={attachment.link}
                    attachment={attachment}
                    onTipiLinkClick={onTipiLinkClick}
                />
            ))}
        </Box>
    );
};
